module.exports = __webpack_public_path__ + "static/img/HanYuan_huajiao.a9bd915f.png";